import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHead } from "@/components/Filters";
import { api } from "@/lib/api";

const CARDS = [
  ["batches", "Total batches"],
  ["published_batches", "Published"],
  ["blocked_batches", "Blocked"],
  ["allotments", "Allotment records"],
  ["closing_ranks", "Closing rank rows"],
  ["fee_records", "Fee records"],
  ["colleges", "Colleges"],
  ["users", "Users"],
  ["paid_users", "MasterPlan users"],
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [log, setLog] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/admin/audit-log").then(({ data }) => setLog(data.slice(0, 12))).catch(() => {});
  }, []);

  return (
    <div className="space-y-5" data-testid="admin-dashboard">
      <PageHead
        title="Ingestion overview"
        subtitle="Nothing reaches the user app until a batch passes validation and is published."
        right={
          <Link
            to="/admin/upload"
            data-testid="dashboard-upload-btn"
            className="bg-[#1A365D] px-4 py-2 text-xs font-semibold uppercase tracking-widest text-white hover:bg-[#122845]"
          >
            New upload
          </Link>
        }
      />
      <div className="grid gap-px border border-slate-200 bg-slate-200 sm:grid-cols-3 lg:grid-cols-5">
        {CARDS.map(([k, label]) => (
          <div key={k} className="bg-white p-4" data-testid={`stat-${k}`}>
            <p className="font-mono-num text-2xl font-semibold text-slate-900">
              {stats ? (stats[k] ?? 0).toLocaleString("en-IN") : "—"}
            </p>
            <p className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-slate-500">{label}</p>
          </div>
        ))}
      </div>

      <div>
        <h2 className="font-display text-lg font-bold text-slate-900">Recent activity</h2>
        {log.length === 0 ? (
          <p className="mt-2 border border-dashed border-slate-300 bg-white p-6 text-center text-sm text-slate-500">
            No ingestion activity yet.
          </p>
        ) : (
          <table className="data-table mt-2 border border-slate-200 bg-white" data-testid="audit-table">
            <thead>
              <tr>
                <th>When</th>
                <th>Action</th>
                <th>Actor</th>
                <th>Detail</th>
              </tr>
            </thead>
            <tbody>
              {log.map((l) => (
                <tr key={l.id}>
                  <td className="font-mono-num">{new Date(l.at).toLocaleString("en-IN")}</td>
                  <td className="font-semibold uppercase">{l.action}</td>
                  <td>{l.actor || "—"}</td>
                  <td>{l.detail}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
